/* KTS Turntable Buying Quiz v6 — Live Shopify products + PDF fixes */
(function () {
  'use strict';

  const QUESTIONS = [
    {
      key: 'collection_size',
      text_key: 'q_collection_size',
      layout: 'grid-2',
      options: [
        { value: '0_25',    label_key: 'opt_coll_0_25',    tags: ['casual','small_collection','starter_serious'] },
        { value: '25_100',  label_key: 'opt_coll_25_100',  tags: ['starter_serious','growing_collection'] },
        { value: '100_300', label_key: 'opt_coll_100_300', tags: ['audiophile_sweet_spot','musicality','versatile'] },
        { value: '300_plus',label_key: 'opt_coll_300_plus',tags: ['audiophile_sweet_spot','reference_classic','lifetime_keeper'] }
      ]
    },
    {
      key: 'budget',
      text_key: 'q_budget',
      layout: 'grid-2',
      options: [
        { value: 'under_300',   label_key: 'opt_bud_under_300',   tier: 'entry' },
        { value: '300_600',     label_key: 'opt_bud_300_600',     tier: 'quality' },
        { value: '600_1200',    label_key: 'opt_bud_600_1200',    tier: 'audiophile' },
        { value: 'over_1200',   label_key: 'opt_bud_over_1200',   tier: 'reference' }
      ]
    },
    {
      key: 'setup_type',
      text_key: 'q_setup_type',
      layout: 'grid-2',
      options: [
        { value: 'all_in_one',  label_key: 'opt_setup_all_in_one', prefs: { phono_builtin: true, auto: true } },
        { value: 'amp_speakers',label_key: 'opt_setup_amp_speakers', prefs: {} },
        { value: 'bluetooth',   label_key: 'opt_setup_bluetooth',  prefs: { bluetooth: true }, tags: ['bluetooth_needed'] },
        { value: 'full_system', label_key: 'opt_setup_full_system', tags: ['audiophile_sweet_spot','reference_classic'] }
      ]
    },
    {
      key: 'usage_freq',
      text_key: 'q_usage_freq',
      layout: 'grid-2',
      options: [
        { value: 'weekly',  label_key: 'opt_use_weekly',  tags: ['casual','value'] },
        { value: 'few_week',label_key: 'opt_use_few_week',tags: ['starter_serious','versatile'] },
        { value: 'daily',   label_key: 'opt_use_daily',   tags: ['musicality','lifetime_keeper'] },
        { value: 'ritual',  label_key: 'opt_use_ritual',  tags: ['audiophile_sweet_spot','reference_classic','lifetime_keeper'] }
      ]
    },
    {
      key: 'priority',
      text_key: 'q_priority',
      layout: 'grid-2',
      options: [
        { value: 'convenience', label_key: 'opt_prio_convenience', tags: ['casual'], prefs: { auto: true, phono_builtin: true } },
        { value: 'sound_quality',label_key: 'opt_prio_sound',       tags: ['musicality','audiophile_sweet_spot'] },
        { value: 'build_quality',label_key: 'opt_prio_build',       tags: ['lifetime_keeper','reference_classic'] },
        { value: 'versatility',  label_key: 'opt_prio_versatility', tags: ['versatile','direct_drive'] }
      ]
    },
    {
      key: 'cart_upgrade_plan',
      text_key: 'q_cart_upgrade',
      layout: 'grid-1',
      options: [
        { value: 'yes_soon',   label_key: 'opt_cart_yes_soon',   prefs: { cartridge_upgradeable: true }, tags: ['musicality'] },
        { value: 'maybe',      label_key: 'opt_cart_maybe',      prefs: { cartridge_upgradeable: true } },
        { value: 'no',         label_key: 'opt_cart_no' }
      ]
    },
    {
      key: 'space_constraints',
      text_key: 'q_space',
      layout: 'grid-1',
      options: [
        { value: 'tight',   label_key: 'opt_space_tight',   tags: ['minimalist'] },
        { value: 'normal',  label_key: 'opt_space_normal' },
        { value: 'plenty',  label_key: 'opt_space_plenty',  tags: ['reference_classic'] }
      ]
    }
  ];

  const MAX_SCORE = 25 + 6*4 + 5*3 + 8;

  function scoreTurntable(tt, answers) {
    let score = 0;
    const reasons = [];

    const budgetOpt = QUESTIONS[1].options.find(o => o.value === answers.budget);
    if (budgetOpt && tt.tier === budgetOpt.tier) {
      score += 25;
      reasons.push('budget_match');
    } else if (budgetOpt) {
      const tiers = ['entry','quality','audiophile','reference'];
      const delta = Math.abs(tiers.indexOf(tt.tier) - tiers.indexOf(budgetOpt.tier));
      if (delta === 1) score += 8;
      else if (delta === 2) score -= 5;
      else score -= 15;
    }

    const allTags = new Set();
    QUESTIONS.forEach(q => {
      const ans = answers[q.key];
      const opt = q.options.find(o => o.value === ans);
      if (opt && opt.tags) opt.tags.forEach(t => allTags.add(t));
    });
    const overlap = (tt.use_cases || []).filter(u => allTags.has(u));
    score += overlap.length * 6;
    if (overlap.length > 0) reasons.push('usecase_match');

    QUESTIONS.forEach(q => {
      const ans = answers[q.key];
      const opt = q.options.find(o => o.value === ans);
      if (opt && opt.prefs) {
        Object.entries(opt.prefs).forEach(([key, val]) => {
          if (tt[key] === val) { score += 5; reasons.push('pref_match:' + key); }
          else { score -= 3; }
        });
      }
    });

    if (tt.ktsStocked) { score += 8; reasons.push('kts_stocked'); }
    else if (tt.ktsComing) { score += 4; reasons.push('kts_coming'); }

    return { score, reasons };
  }

  function rankTurntables(db, answers) {
    const scored = db.turntables.map(tt => {
      const { score, reasons } = scoreTurntable(tt, answers);
      return { ...tt, _score: score, _reasons: reasons };
    });
    scored.sort((a, b) => b._score - a._score);
    return scored.slice(0, 3);
  }


  /* === KTS STORAGE TIERS ===
     Maps projected collection size → real Shopify product handle.
     Live data (title/price/image/url) is fetched from /products/{handle}.js on init(). */
  const KTS_TIERS = {
    'tier1_modular_1':  { handle: 'vinyl-modular-stackable-vinyl-record-storage-50-lps',    capacity: 50 },
    'tier2_foreigner':  { handle: 'modular-foreigner-combined-vinyl-storage-system-120-lps',capacity: 120 },
    'tier3_modular_x4': { handle: 'vinyl-modular-x4-modular-vinyl-storage-system-200-lps',  capacity: 200 },
    'tier4_diggers':    { handle: 'the-digger-s-wall-complete-vinyl-station-600-lp',        capacity: 600 }
  };

  /* Fallback data in case fetch fails (rare — keeps UI functional offline) */
  const FALLBACK_PRODUCT = {
    title: 'KTS Storage',
    image: 'https://cdn.shopify.com/s/files/1/0785/7415/8173/files/VINYL-MODULAR-X4-4.jpg?v=1766931850',
    price_eur: 0,
    url: '/products/vinyl-modular-x4-modular-vinyl-storage-system-200-lps'
  };

  function pickTierByProjection(projected) {
    if (projected < 80)         return 'tier1_modular_1';
    else if (projected < 180)   return 'tier2_foreigner';
    else if (projected < 280)   return 'tier3_modular_x4';
    else                        return 'tier4_diggers';
  }

  window.ktsTurntableQuiz = function () {
    return {
      step: 0,
      totalSteps: QUESTIONS.length,
      questions: QUESTIONS,
      answers: {},
      db: null,
      showResults: false,
      topPicks: [],
      storageProjection: null,
      optedIn: false,
      optinEmail: '',
      optinError: '',
      locale: (window.KTS_QUIZ_LOCALE_PREFIX || 'en').replace(/"/g,''),
      i18nBag: window.KTS_QUIZ_I18N || {},
      contentPack: null,
      ktsProductsLive: {}, /* { handle: { title, image, price_eur, url } } */

      i18n(key, fallback) {
        if (this.i18nBag[key] != null) return this.i18nBag[key];
        if (this.contentPack) {
          for (const section of ['questions','options','profiles','pros','tiers']) {
            const val = this.contentPack[section] && this.contentPack[section][key];
            if (val != null) return val;
          }
        }
        return fallback !== undefined ? fallback : key;
      },

      i18nOpt(key) { return this.i18n(key, ''); },

      get currentQ() {
        const q = this.questions[this.step];
        if (!q) return { key: '', q: '', sub: '', options: [], layout: 'grid-2' };
        return {
          key: q.key,
          layout: q.layout,
          q:   this.i18n(q.text_key),
          sub: this.i18nOpt(q.text_key + '_sub'),
          options: (q.options || []).map(o => ({
            value: o.value,
            icon:  o.icon || '',
            label: this.i18n(o.label_key),
            sub:   this.i18nOpt(o.label_key + '_sub'),
            tags:  o.tags || [],
            tier:  o.tier,
            prefs: o.prefs || {}
          }))
        };
      },

      get recommendations() {
        if (!this.topPicks || !this.topPicks.length) return [];
        const scores = this.topPicks.map(t => t._score);
        const maxObserved = Math.max(...scores, MAX_SCORE * 0.5);
        return this.topPicks.map(tt => {
          const pct = Math.max(50, Math.min(99, Math.round((tt._score / maxObserved) * 100)));
          const pros = (tt.pros_keys || []).map(k => this.i18n(k)).filter(Boolean);
          return {
            id:             tt.id,
            brand:          tt.brand,
            model:          tt.model,
            tier:           tt.tier,
            price_eur:      tt.price_eur,
            price_usd:      tt.price_eur,
            image:          tt.image,
            use_cases:      tt.use_cases,
            pros:           pros,
            profile:        this.i18n(tt.profile_key, ''),
            match_pct:      pct,
            ktsStocked:     tt.ktsStocked,
            ktsComing:      tt.ktsComing,
            ktsProductHandle: tt.ktsProductHandle,
            affiliateUrl:   tt.affiliateUrl
          };
        });
      },

      async fetchKTSProductsLive() {
        const prefix = (this.locale && this.locale !== 'en') ? ('/' + this.locale) : '';
        const handles = Object.values(KTS_TIERS).map(t => t.handle);
        const results = await Promise.allSettled(
          handles.map(h => fetch('/products/' + h + '.js', { credentials: 'same-origin' })
            .then(r => r.ok ? r.json() : null))
        );
        handles.forEach((h, i) => {
          const r = results[i];
          if (r.status === 'fulfilled' && r.value) {
            const p = r.value;
            let img = p.featured_image || (p.images && p.images[0]) || '';
            if (img && img.startsWith('//')) img = 'https:' + img;
            this.ktsProductsLive[h] = {
              title:     (p.title || '').replace(/\s*[-–—]\s*.*$/,'').replace(/\s*\([^)]*\)\s*$/,'').trim() || p.title,
              title_full: p.title,
              image:     img,
              price_eur: Math.round((p.price_min || p.price || 0) / 100),
              url:       'https://keepthemspinning.com' + prefix + '/products/' + h
            };
          } else {
            this.ktsProductsLive[h] = Object.assign({}, FALLBACK_PRODUCT, {
              url: 'https://keepthemspinning.com' + prefix + '/products/' + h
            });
          }
        });
      },

      async init() {
        try {
          const [dbRes, contentRes] = await Promise.all([
            fetch(window.KTS_QUIZ_DB_URL),
            fetch(window.KTS_QUIZ_CONTENT_URL || '')
          ]);
          this.db = await dbRes.json();
          if (contentRes.ok) {
            const all = await contentRes.json();
            const loc = (this.locale || 'en').split('-')[0];
            this.contentPack = all[loc] || all['en'];
          }
        } catch (e) {
          console.error('[KTS Quiz] asset load failed', e);
        }
        /* fire-and-forget: fetch live KTS products in parallel with quiz */
        this.fetchKTSProductsLive().catch(e => console.error('[KTS Quiz] product fetch failed', e));
      },

      selectOption(val) {
        this.answers[this.currentQ.key] = val;
        setTimeout(() => this.nextStep(), 180);
      },

      nextStep() {
        if (this.step < this.totalSteps - 1) { this.step++; }
        else { this.compute(); }
      },
      next() { this.nextStep(); },

      prevStep() {
        if (this.step > 0) this.step--;
      },
      prev() { this.prevStep(); },

      projectStorage(collectionSize, usageFreq) {
        const sizeRanges = {
          '0_25':     { current: 15,  growth: 15 },
          '25_100':   { current: 60,  growth: 60 },
          '100_300':  { current: 200, growth: 90 },
          '300_plus': { current: 400, growth: 120 }
        };
        const freqMult = { weekly: 0.6, few_week: 1.0, daily: 1.3, ritual: 1.6 };
        const base = sizeRanges[collectionSize] || sizeRanges['25_100'];
        const mult = freqMult[usageFreq] || 1.0;
        const projected = Math.round(base.current + (base.growth * mult));

        const tierKey   = pickTierByProjection(projected);
        const tierData  = KTS_TIERS[tierKey];
        const capacity  = tierData.capacity;
        const unitsNeed = Math.max(1, Math.ceil(projected / capacity));
        const meters    = projected * 0.003;

        /* Build live product cards from ktsProductsLive — always use real Shopify data */
        const buildCard = (handle, primary) => {
          const live = this.ktsProductsLive[handle] || FALLBACK_PRODUCT;
          const tier = Object.values(KTS_TIERS).find(t => t.handle === handle);
          return {
            handle:    handle,
            primary:   !!primary,
            name:      live.title || 'KTS Storage',
            image:     live.image || '',
            capacity:  (tier && tier.capacity) || 0,
            price_eur: live.price_eur || 0,
            url:       live.url || ('/products/' + handle)
          };
        };

        const primaryCard = buildCard(tierData.handle, true);
        /* Alt card: always show Modular x4 as entry-to-serious recommendation,
           unless primary IS x4, in which case show Foreigner (120 LPs)  */
        let altHandle = 'vinyl-modular-x4-modular-vinyl-storage-system-200-lps';
        if (tierData.handle === altHandle) {
          altHandle = 'modular-foreigner-combined-vinyl-storage-system-120-lps';
        }
        const altCard = buildCard(altHandle, false);

        return {
          projected_count: projected,
          current:         base.current,
          meters:          meters,
          tier_key:        tierKey,
          tier_label:      primaryCard.name,
          capacity:        capacity,
          units:           unitsNeed,
          products:        [primaryCard, altCard]
        };
      },

      compute() {
        if (!this.db) return;
        this.topPicks = rankTurntables(this.db, this.answers);
        this.storageProjection = this.projectStorage(this.answers.collection_size, this.answers.usage_freq);
        this.showResults = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (window.dataLayer) {
          window.dataLayer.push({ event: 'kts_quiz_complete', top_pick: this.topPicks[0]?.id, tier: this.topPicks[0]?.tier });
        }
      },

      restart() {
        this.step = 0;
        this.answers = {};
        this.topPicks = [];
        this.storageProjection = null;
        this.showResults = false;
        this.optedIn = false;
        this.optinEmail = '';
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },

      ktsProductUrl(handle) {
        if (!handle) return '#';
        const live = this.ktsProductsLive[handle];
        if (live && live.url) return live.url;
        const prefix = (this.locale && this.locale !== 'en') ? ('/' + this.locale) : '';
        return prefix + '/products/' + handle;
      },

      trackCta(tt, idx) {
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'kts_quiz_cta_click',
            turntable_id: tt.id,
            turntable_brand: tt.brand,
            turntable_model: tt.model,
            rank: idx + 1,
            destination: tt.ktsStocked ? 'kts_product' : (tt.ktsComing ? 'kts_notify' : 'retailer')
          });
        }
      },

      shareResult() {
        const top = this.recommendations[0];
        const url = window.location.href.split('?')[0];
        const title = this.i18n('share_title', 'My KTS turntable match');
        const text = top ? `${top.brand} ${top.model} — ${top.match_pct}% match` : '';
        if (navigator.share) {
          navigator.share({ title, text, url }).catch(() => {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(() => {
            alert(this.i18n('share_copied', 'Link copied!'));
          });
        }
      },

      async submitOptin() {
        const email = (this.optinEmail || '').trim();
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          this.optinError = 'invalid email';
          return;
        }
        try {
          const top = this.recommendations[0];
          const proj = this.storageProjection || {};
          // 1. Subscribe to newsletter list
          await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=U7Hs7c', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email: email,
                        properties: {
                          quiz_top_pick: top?.id,
                          quiz_brand: top?.brand,
                          quiz_model: top?.model,
                          quiz_match_pct: top?.match_pct,
                          quiz_tier: top?.tier,
                          quiz_storage_tier: proj.tier_key,
                          quiz_storage_count: proj.projected_count,
                          quiz_locale: this.locale,
                          quiz_completed_at: new Date().toISOString()
                        }
                      }
                    }
                  },
                  custom_source: 'turntable-quiz'
                },
                relationships: {
                  list: { data: { type: 'list', id: 'W9cAA4' } }
                }
              }
            })
          });
          // 2. Push tracked event for Klaviyo flows
          await fetch('https://a.klaviyo.com/client/events/?company_id=U7Hs7c', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
            body: JSON.stringify({
              data: {
                type: 'event',
                attributes: {
                  profile: { data: { type: 'profile', attributes: { email: email } } },
                  metric: { data: { type: 'metric', attributes: { name: 'Completed Turntable Quiz' } } },
                  properties: {
                    top_brand: top?.brand,
                    top_model: top?.model,
                    match_pct: top?.match_pct,
                    tier: top?.tier,
                    storage_tier: proj.tier_key,
                    storage_count: proj.projected_count,
                    locale: this.locale
                  }
                }
              }
            })
          });
        } catch (e) {
          console.error('[KTS Quiz] Klaviyo error', e);
        }
        this.optedIn = true;
      },

      exportPDF() {
        const top = this.recommendations[0];
        const proj = this.storageProjection;
        if (!top || !proj) { alert(this.i18n('pdf_error','Could not generate PDF')); return; }
        const w = window.open('', '_blank', 'width=820,height=1100');
        if (!w) { alert(this.i18n('pdf_error','Could not open PDF view')); return; }

        const escapeHtml = (s) => String(s||'').replace(/[&<>"']/g, c => ({
          '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'
        }[c]));

        const recCards = this.recommendations.map((tt, idx) => {
          const isBest = idx === 0;
          const badgeLbl = isBest ? this.i18n('best_match','Best match') : this.i18n('alt_match','Also consider');
          const prosList = (tt.pros || []).slice(0,3).map(p => '<li>' + escapeHtml(p) + '</li>').join('');
          return '<div class="kts-pdf-card ' + (isBest ? 'kts-pdf-card--best' : '') + '">' +
            '<div class="kts-pdf-card__rank">' + escapeHtml(badgeLbl) + '</div>' +
            '<img src="' + escapeHtml(tt.image) + '" alt="' + escapeHtml(tt.brand + ' ' + tt.model) + '" class="kts-pdf-card__img"/>' +
            '<div class="kts-pdf-card__body">' +
              '<div class="kts-pdf-card__brand">' + escapeHtml(tt.brand) + '</div>' +
              '<div class="kts-pdf-card__model">' + escapeHtml(tt.model) + '</div>' +
              '<div class="kts-pdf-card__price">&euro;' + tt.price_eur.toLocaleString() + ' &middot; ' +
                escapeHtml(this.i18n('match_score','Match')) + ' ' + tt.match_pct + '%</div>' +
              '<ul class="kts-pdf-card__pros">' + prosList + '</ul>' +
            '</div></div>';
        }).join('');

        const ktsProds = (proj.products || []).map(p => {
          return '<div class="kts-pdf-prod">' +
            (p.image ? '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.name) + '" class="kts-pdf-prod__img"/>' : '') +
            '<div class="kts-pdf-prod__body">' +
              (p.primary ? '<div class="kts-pdf-prod__badge">' + escapeHtml(this.i18n('recommended_for_you','Recommended for you')) + '</div>' : '') +
              '<div class="kts-pdf-prod__name">' + escapeHtml(p.name) + '</div>' +
              '<div class="kts-pdf-prod__cap">' + (p.capacity||0) + ' LPs &middot; ' + escapeHtml(this.i18n('solid_wood','Solid wood')) + '</div>' +
              (p.price_eur ? '<div class="kts-pdf-prod__price">&euro;' + p.price_eur + '</div>' : '') +
            '</div>' +
          '</div>';
        }).join('');

        /* FIXED v6: removed negative hero margins (was clipping text).
           Hero now uses a full-bleed wrapper inside body that respects @page margin. */
        const css = '@page{size:A4;margin:0}' +
          '*{box-sizing:border-box;-webkit-print-color-adjust:exact;print-color-adjust:exact;color-adjust:exact}' +
          'html,body{margin:0;padding:0}' +
          'body{font-family:"Poppins",-apple-system,Segoe UI,Roboto,sans-serif;color:#1A1A1A;background:#FFFFFF;line-height:1.5;font-size:11pt}' +
          '.kts-pdf-hero{background:#1A1A1A;color:#FFFFFF;padding:28px 16mm 30px;position:relative;width:100%;border-bottom:4px solid #FFBD00}' +
          '.kts-pdf-brand{font-family:"Roboto Condensed",Impact,sans-serif;letter-spacing:3px;font-weight:700;font-size:11px;color:#FFBD00;text-transform:uppercase;margin-bottom:8px}' +
          '.kts-pdf-h1{font-family:"Roboto Condensed",Impact,sans-serif;font-weight:700;font-size:30px;margin:0 0 6px;line-height:1.1;color:#FFFFFF}' +
          '.kts-pdf-hero-sub{font-size:13px;color:rgba(255,255,255,0.72);margin:0}' +
          '.kts-pdf-main{padding:22px 16mm 16mm}' +
          '.kts-pdf-section-title{font-family:"Roboto Condensed",Impact,sans-serif;font-weight:700;font-size:16px;text-transform:uppercase;letter-spacing:1.5px;color:#1A1A1A;margin:22px 0 12px;padding-bottom:6px;border-bottom:3px solid #FFBD00;display:inline-block}' +
          '.kts-pdf-section-title:first-of-type{margin-top:4px}' +
          '.kts-pdf-cards{display:flex;flex-direction:column;gap:10px}' +
          '.kts-pdf-card{display:flex;align-items:stretch;border:1.5px solid #E6E4E4;border-radius:6px;padding:0;overflow:hidden;position:relative;page-break-inside:avoid;background:#FFFFFF}' +
          '.kts-pdf-card--best{border-color:#FFBD00;border-width:2px;background:#FFFBF0}' +
          '.kts-pdf-card__rank{position:absolute;top:0;right:0;background:#FFBD00;color:#1A1A1A;font-family:"Roboto Condensed",sans-serif;font-weight:700;font-size:10px;text-transform:uppercase;letter-spacing:1px;padding:5px 9px;border-radius:0 0 0 4px;z-index:2}' +
          '.kts-pdf-card--best .kts-pdf-card__rank{background:#1A1A1A;color:#FFBD00}' +
          '.kts-pdf-card__img{width:100px;height:100px;object-fit:cover;background:#1A1A1A;flex-shrink:0}' +
          '.kts-pdf-card__body{padding:12px 16px 12px 18px;flex:1}' +
          '.kts-pdf-card__brand{font-size:9px;color:#666;text-transform:uppercase;letter-spacing:1.5px;font-weight:600}' +
          '.kts-pdf-card__model{font-family:"Roboto Condensed",sans-serif;font-size:17px;font-weight:700;margin:2px 0 3px;color:#1A1A1A;line-height:1.15}' +
          '.kts-pdf-card__price{font-size:12px;color:#996B00;font-weight:600;margin-bottom:5px}' +
          '.kts-pdf-card__pros{margin:0;padding-left:15px;font-size:10.5px;color:#333;line-height:1.45}' +
          '.kts-pdf-card__pros li{margin-bottom:1px}' +
          '.kts-pdf-stats{display:flex;gap:0;border:1.5px solid #E6E4E4;border-radius:6px;overflow:hidden;margin-bottom:14px}' +
          '.kts-pdf-stat{flex:1;padding:14px 12px;text-align:center;border-right:1px solid #E6E4E4}' +
          '.kts-pdf-stat:last-child{border-right:0}' +
          '.kts-pdf-stat__val{font-family:"Roboto Condensed",sans-serif;font-size:22px;font-weight:700;color:#1A1A1A;display:block;line-height:1}' +
          '.kts-pdf-stat__lbl{font-size:9px;color:#666;text-transform:uppercase;letter-spacing:1.2px;margin-top:6px;display:block;font-weight:600}' +
          '.kts-pdf-prods{display:flex;gap:10px;flex-wrap:nowrap}' +
          '.kts-pdf-prod{flex:1;min-width:0;border:1.5px solid #1A1A1A;border-radius:6px;overflow:hidden;background:#FFFFFF;display:flex;flex-direction:column;page-break-inside:avoid}' +
          '.kts-pdf-prod__img{width:100%;height:120px;object-fit:cover;background:#F5F5F5;display:block}' +
          '.kts-pdf-prod__body{padding:12px 14px;flex:1;display:flex;flex-direction:column}' +
          '.kts-pdf-prod__badge{font-family:"Roboto Condensed",sans-serif;font-size:9px;font-weight:700;letter-spacing:1.2px;color:#996B00;text-transform:uppercase;margin-bottom:5px}' +
          '.kts-pdf-prod__name{font-family:"Roboto Condensed",sans-serif;font-weight:700;font-size:15px;color:#1A1A1A;margin-bottom:3px;line-height:1.15}' +
          '.kts-pdf-prod__cap{font-size:10px;color:#666;text-transform:uppercase;letter-spacing:0.8px;margin-bottom:6px}' +
          '.kts-pdf-prod__price{font-family:"Roboto Condensed",sans-serif;font-size:17px;font-weight:700;color:#996B00;margin-top:auto}' +
          '.kts-pdf-footer{margin-top:24px;padding-top:14px;border-top:2px solid #1A1A1A;display:flex;justify-content:space-between;align-items:center;font-size:9.5px;color:#666}' +
          '.kts-pdf-footer strong{color:#1A1A1A;font-family:"Roboto Condensed",sans-serif;letter-spacing:1.2px;text-transform:uppercase}';

        const brand = escapeHtml(this.i18n('pdf_brand','Keep Them Spinning'));
        const heroTitle = escapeHtml(this.i18n('pdf_hero_title','Tu informe de tocadiscos').replace('Tu informe de tocadiscos', this.i18n('pdf_hero_title','Your turntable report')));
        const heroSub = escapeHtml(this.i18n('pdf_hero_sub','Recomendaciones personalizadas basadas en tus respuestas').replace('Recomendaciones personalizadas basadas en tus respuestas', this.i18n('pdf_hero_sub','Personalized recommendations based on your answers')));
        const secMatches = escapeHtml(this.i18n('pdf_sec_matches','Tus tocadiscos recomendados'));
        const secStorage = escapeHtml(this.i18n('pdf_sec_storage','Proyección de almacenaje'));
        const secStoragePair = escapeHtml(this.i18n('pdf_sec_storage_pair','Almacenaje KTS para tu colección'));
        const statNowLbl = escapeHtml(this.i18n('collection_now','Collection now'));
        const stat24Lbl = escapeHtml(this.i18n('in_24_months','In 24 months'));
        const statMetersLbl = escapeHtml(this.i18n('linear_meters','Linear meters'));
        const ftBrand = escapeHtml(this.i18n('pdf_footer_brand','keepthemspinning.com'));
        const ftDate = new Date().toLocaleDateString(this.locale || 'en', { year:'numeric', month:'long', day:'numeric' });

        const html =
          '<!doctype html><html><head><meta charset="utf-8"/>' +
          '<title>' + heroTitle + ' — ' + brand + '</title>' +
          '<link rel="preconnect" href="https://fonts.googleapis.com">' +
          '<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>' +
          '<link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&family=Roboto+Condensed:wght@400;700&display=swap" rel="stylesheet">' +
          '<style>' + css + '</style>' +
          '</head><body>' +
          '<div class="kts-pdf-hero">' +
            '<div class="kts-pdf-brand">' + brand + '</div>' +
            '<h1 class="kts-pdf-h1">' + heroTitle + '</h1>' +
            '<p class="kts-pdf-hero-sub">' + heroSub + '</p>' +
          '</div>' +
          '<div class="kts-pdf-main">' +
            '<div class="kts-pdf-section-title">' + secMatches + '</div>' +
            '<div class="kts-pdf-cards">' + recCards + '</div>' +
            '<div class="kts-pdf-section-title">' + secStorage + '</div>' +
            '<div class="kts-pdf-stats">' +
              '<div class="kts-pdf-stat"><span class="kts-pdf-stat__val">' + (proj.current||0) + '</span><span class="kts-pdf-stat__lbl">' + statNowLbl + '</span></div>' +
              '<div class="kts-pdf-stat"><span class="kts-pdf-stat__val">' + (proj.projected_count||0) + '</span><span class="kts-pdf-stat__lbl">' + stat24Lbl + '</span></div>' +
              '<div class="kts-pdf-stat"><span class="kts-pdf-stat__val">' + (proj.meters ? proj.meters.toFixed(2) : '0') + 'm</span><span class="kts-pdf-stat__lbl">' + statMetersLbl + '</span></div>' +
            '</div>' +
            '<div class="kts-pdf-section-title">' + secStoragePair + '</div>' +
            '<div class="kts-pdf-prods">' + ktsProds + '</div>' +
            '<div class="kts-pdf-footer">' +
              '<span><strong>' + ftBrand + '</strong></span>' +
              '<span>' + ftDate + '</span>' +
            '</div>' +
          '</div>' +
          '<scr' + 'ipt>' +
            'function waitForImages(){var imgs=Array.from(document.images);if(imgs.length===0)return Promise.resolve();return Promise.all(imgs.map(function(img){if(img.complete&&img.naturalWidth>0)return Promise.resolve();return new Promise(function(res){img.onload=img.onerror=function(){res();};setTimeout(res,4000);});}));}' +
            'function waitForFonts(){return document.fonts?document.fonts.ready:Promise.resolve();}' +
            'window.addEventListener("load",function(){Promise.all([waitForImages(),waitForFonts()]).then(function(){setTimeout(function(){window.print();},350);});});' +
          '</scr' + 'ipt>' +
          '</body></html>';

        w.document.open();
        w.document.write(html);
        w.document.close();
      }
    };
  };
})();
